import React, { useState, useEffect } from 'react';
import './CustomTree.scss'; 
import UtilityService from '../../services/UtillityServices/UtilityService';

const CustomTree = ({ areas, setSelectedNodeTree, setModalStateAree, setInputAreaValue, setSelectedContenuto }) => {
  const [openFolders, setOpenFolders] = useState(() => {
    const saved = localStorage.getItem('openFolders');
    return saved ? new Set(JSON.parse(saved)) : new Set();
  });

  useEffect(() => {
    localStorage.setItem('openFolders', JSON.stringify([...openFolders]));
  }, [openFolders]);

  const generateMenuData = (areas) => {
    return areas?.sort((a, b) => a.id_area - b.id_area).map((area) => ({
      ...area,
      label: area.titolo,
      hasChildren: (area.children?.length > 0) || (area.contenuti?.length > 0),
      submenu: generateSubMenu(area),
    }));
  };
  const openModalEditArea = (area) => {
    setSelectedNodeTree(area)
    setInputAreaValue(area.label)
    setModalStateAree(state => ({ 
      ...state,
      showModalUpdateAreaOrSottoarea: true, 
    }));
  }

  const generateSubMenu = (area) => {
    const subMenu = [];
  
    const sortedContents = [...area.contenuti].sort((a, b) => a.id_contenuto - b.id_contenuto);
    sortedContents.forEach((contenuto) => {
      subMenu.push({
        ...contenuto,
        label: contenuto.titolo,
        isContenuto: true,
        hasChildren: false, 
      });
    });
  
    const sortedChildren = [...area.children].sort((a, b) => a.id_area - b.id_area);
    sortedChildren.forEach((childArea) => {
      subMenu.push({
        ...childArea,
        label: childArea.titolo,
        hasChildren: (childArea.children?.length > 0) || (childArea.contenuti?.length > 0),
        submenu: generateSubMenu(childArea),
      });
    });
  
    return subMenu;
  };

  const menuData = generateMenuData(areas);

  const toggleSubMenu = (e, item) => {
    e.stopPropagation();
    
    if(item.isContenuto) {
      setSelectedContenuto(item);
      localStorage.setItem('selectedContenutoId', item.id_contenuto);
      return;
    }

    setOpenFolders(prev => {
      const newSet = new Set(prev);
      if (newSet.has(item.id_area)) {
        newSet.delete(item.id_area);
      } else {
        newSet.add(item.id_area);
      }
      return newSet;
    });
  };

  const renderSubMenu = (subMenu) => {
    return (
      <ul className="submenu" style={{ 
        display: "block",  
        listStyle: "none", 
        paddingLeft: '5px' 
      }}>
        {subMenu?.map((subItem, index) => {
          const isFolder = !subItem.isContenuto;
          const isOpen = openFolders.has(subItem.id_area);
          
          return (
            <li key={index}>
              <div onClick={(e) => toggleSubMenu(e, subItem)} style={{ cursor: 'pointer' }}>
                {subItem.isContenuto ? renderBootstrapIconContenuto(subItem) : renderBootstrapIconArea(subItem.hasChildren)} 
                {subItem.label}
                {!subItem.isContenuto && (
                  <span onClick={(e) => {
                    e.stopPropagation();
                    openModalEditArea(subItem);
                  }} className="bi bi-pencil edit-icon text-dark ms-1 small"></span>
                )}
              </div>
              {isFolder && subItem.submenu && (
                <div style={{ display: isOpen ? 'block' : 'none' }}>
                  {renderSubMenu(subItem.submenu)}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    );
  };
  

  const renderBootstrapIconArea = (hasChildren) => {
    return hasChildren ? <span className="bi bi-folder-fill text-primary"></span> : <span className="bi bi-folder text-primary"></span>;
  };

  const renderBootstrapIconContenuto = (contenuto) => {
   return UtilityService.generateIconContenuti(contenuto)

  };

  return (
    <div>
      <ul style={{ listStyle: "none", paddingLeft: '5px' }}>
        {menuData?.map((item, index) => {
          const isOpen = openFolders.has(item.id_area);
          
          return (
            <li key={index}>
              <div onClick={(e) => toggleSubMenu(e, item)} style={{ cursor: 'pointer' }}>
                {renderBootstrapIconArea(item.hasChildren)} {item.label}
                <span 
                  onClick={(e) => {
                    e.stopPropagation();
                    openModalEditArea(item);
                  }} 
                  className="bi bi-pencil edit-icon text-dark ms-1 small"
                />
              </div>
              {item.submenu && (
                <div style={{ display: isOpen ? 'block' : 'none' }}>
                  {renderSubMenu(item.submenu)}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default CustomTree;
